<template>
    <div>
        <div class="hint block">
            <p><i class="icon iconfont icon-tongzhi1 mr10 font-gold"></i><span>提示:上传附件大小不可超过5M</span></p>
        </div>
        <div class="form-value">
            <div class="simple-row">
                <div class="left">
                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                </div>
            </div>
            <ul class="file-area input clearfix" v-if="imgList.length > 0">
                <li class="file-content clearfix" :class="{'active': img.checked}" v-for="(img, index) in imgList">
                    <swb-file-item :trackKey="index" :fileName="img.dispName" :fileUuid="img.fileUuid" :fileBrowseUrl="img.fileBrowseUrl" :fileDownloadUrl="img.fileDownLoadUrl"
                                   :fileMd5="img.fileMd5" :deletable="true" :onDelete="deleteFile"></swb-file-item>
                    <el-input :title="img.fileName" v-model="img.fileName" placeholder="文件名称不可多于20个字"></el-input>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import servcDelivApi from '../../api/servcDeliv';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    export default {
        name: 'swb-goods-order-img-edit',
        desc: '订单附件上传',
        props: ["count"],
        data: function () {

            return {
                // 资产图片
                imgList: [],
            }
        },
        created: function () {
        },
        methods: {
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                let count = this.count + this.imgList.length;
                if (fileItems.length > 10) {
                    MsgBox.warning("一次最多上传10个附件");
                    return false;
                }
                if (fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
                Toast.show("正在上传" + percentage + "%", 3000);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                let imgList = self.imgList || [];
                if (result.type === 'info') {
                    let files = result.data.files || [];
                    for (let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let img = {};
                        img.dispName = file.fileName;
                        img.fileName = file.fileName;
                        img.fileUuid = file.fileUuid;
                        img.fileExtName = file.fileExtName;
                        img.fileBrowseUrl = file.fileBrowseUrl;
                        img.fileDownLoadUrl = file.fileDownloadUrl;
                        img.fileMd5 = file.fileMd5;
                        img.add = true;
                        img.checked = false;
                        imgList.prepend(img);
                    }
                    self.imgList = Utils.merge([], imgList);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            deleteFile: function (index) {
                this.imgList.removeAt(index.trackKey);
                return false;
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let imgList = self.imgList || [];
                if (imgList.length <= 0) {
                    result.message = "请上传附件信息";
                    result.type = "warn";
                    return result;
                }
                let descLengFlag = false;
                for (let i = 0; i < imgList.length; i++) {
                    let img = imgList[i];
                    if (img.fileName.length > 20) {
                        descLengFlag = true;
                        break;
                    }
                }
                if (descLengFlag) {
                    result.message = "文件名称不可多于20个字";
                    result.type = "warn";
                } else {
                    result.data = imgList;
                    result.type = "info";
                }

                return result;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/order/GoodsOrderImgSave.vue